import React from 'react'
import { FaInstagram, FaVimeoV, FaFacebook, FaLinkedinIn, FaYoutube } from 'react-icons/fa'

const SocialIcons = () => {
    return (
        <div>
            <div className="social_icons">
                <ul>
                    <li>
                        <a href="https://www.Instagram.com/littlebigglobal" target="_blank" >
                            <FaInstagram />
                        </a>
                    </li>
                    <li>
                        <a href="https://vimeo.com/littlebigglobal" target="_blank">
                            <FaVimeoV />
                        </a>
                    </li>
                    <li>
                        <a href="https://www.facebook.com/LittleBigGlobal" target="_blank">
                            <FaFacebook />
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/little-big-productions" target="_blank">
                            <FaLinkedinIn />
                        </a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/user/LittleBigSA" target="_blank">
                            <FaYoutube />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default SocialIcons